import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=4ed5ff1e&"
import script from "./Donation.vue?vue&type=script&lang=js&"
export * from "./Donation.vue?vue&type=script&lang=js&"
import style0 from "./Donation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports